<template src="./html/Index.html"></template>

<script>
	import Create from './../views/Create.vue'
	import Edit from './../views/Edit.vue'
	import swal from 'sweetalert2'

	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'create': Create,
			'edit': Edit,
			'datatable': Datatable,
		},
		data () {
			return {
				resource: 'departments',
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.reload())
			},
			destroy: function(department) {
				var that = this

				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/departments/' + department.id)
							.then(response => {
								that.$refs.datatable.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								swal({
									title: response.statusText,
									text: response.body,
									type: "warning"
								});
							})
						})
					}
				}]).catch(swal.noop)
			},
			changeStatus: function(department) {
				var status_id = department.status_id
				var api = 'admin/'+this.resource+'/'+department.id+'/change/status'
				this.$http.get(api)
					.then(response => {
						department.status_id = response.body.data.status_id
					}).catch(function(response) {
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning"
						});
					})
			},
			edit(data) {
				this.$refs.edit.open(data)
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/departments/views/Index.vue